var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H361.931L2.703 421.218c1.589 1.539 3.737 2.506 6.124 2.506h141.241L509.297 90.782c-1.589-1.54-3.738-2.506-6.125-2.506z",
    fill: "#ffe15a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M361.931 88.276H8.828A8.828 8.828 0 0 0 0 97.103v317.793c0 2.488 1.047 4.717 2.703 6.322L361.931 88.276z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M509.297 90.782L150.069 423.724h353.103a8.829 8.829 0 0 0 8.828-8.828V97.103c0-2.489-1.047-4.717-2.703-6.321z",
    fill: "#ff4b55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCg);
export default __webpack_public_path__ + "static/media/cg.395fa1941c9a7cf4c13033d55ab1e2ef.svg";
export { ForwardRef as ReactComponent };